import { render } from "./ContributorsTable.vue?vue&type=template&id=88b70910&scoped=true"
import script from "./ContributorsTable.vue?vue&type=script&lang=js"
export * from "./ContributorsTable.vue?vue&type=script&lang=js"

import "./ContributorsTable.vue?vue&type=style&index=0&id=88b70910&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b70910"]])

export default __exports__